var map = {
	"./cake.webp": 2378,
	"./correct-ico.webp": 2379,
	"./crown-blue.webp": 2380,
	"./crown.webp": 2381,
	"./pocket.webp": 2382,
	"./present.webp": 2383,
	"./relegation.webp": 2384,
	"./t-deposit.webp": 2385,
	"./t-turnover.webp": 2386,
	"./vip-1.webp": 2387,
	"./vip-2.webp": 2388,
	"./vip-3.webp": 2389,
	"./vip-4.webp": 2390,
	"./vip-5.webp": 2391,
	"./vip-badge.webp": 2392,
	"./vip-bg.webp": 2393,
	"./vip-bonus-bg.webp": 2394,
	"./vip1.webp": 2395,
	"./vip2.webp": 2396,
	"./vip3.webp": 2397,
	"./vip4.webp": 2398,
	"./vip5.webp": 2399,
	"./vip6.webp": 2400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 394;